/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespCollectionsModuleItem_item = {
    readonly title: string | null;
    readonly imageUrl: string | null;
    readonly linkData: {
        readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
    };
    readonly " $refType": "HpRespCollectionsModuleItem_item";
};
export type HpRespCollectionsModuleItem_item$data = HpRespCollectionsModuleItem_item;
export type HpRespCollectionsModuleItem_item$key = {
    readonly " $data"?: HpRespCollectionsModuleItem_item$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespCollectionsModuleItem_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpRespCollectionsModuleItem_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "linkData",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SeoLink_linkData"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Product",
  "abstractKey": null
};
(node as any).hash = 'bd26ca7a69e100c0643049b577ff3e4f';
export default node;
